var MYBOXPAGE = {

    init: function(){
        MYBOXPAGE._initBoxSelector()
    },

    vars: {
        productSelectArray : [],
        productSelectSkuArray : [],
    },

    _initBoxSelector: function() {

        window.addEventListener("beforeunload", function() {
            console.log('beforeunload');
            MAIN.setCookie('abandonedMyBoxPage', Math.round(new Date().getTime() / 1000));
        });
        window.addEventListener("pagehide", function() {
            MAIN.setCookie('abandonedMyBoxPage', Math.round(new Date().getTime() / 1000));
        });

        window.addEventListener("popstate", function() {
            console.log('popstate');
            if(MAIN.getAnchor() === ''){
                console.log('back to step 1');
                MYBOXPAGE.gotoStep(1, false);
            }
        });

        var formMyBox = document.getElementById('form-my-box');

        if (formMyBox) {

            eventBus.$on('product-summary-event-complete', productSummaryEventComplete);

            var couponSelected;
            var boxValue = 0;

            const sectionStepCont = document.querySelector('.step-slider');
            const stepperCont = document.querySelector('stepper');
            const sectionProductSelectors = document.querySelectorAll('.section-product-selector');

            MYBOXPAGE.gotoStep(1, true);

            document.querySelectorAll('.back-to-one').addEventListener('click', function() {
                window.history.back();
            });

            document.querySelectorAll('.back-to-two').addEventListener('click', function() {
                MYBOXPAGE.gotoStep(2, false);
            });

            sectionStepCont.querySelectorAll('.btn-bb-type').addEventListener('click', function(event) {
                const element = this;
                if (event.target.classList.contains('readmoreinfo')) { return; }
                if (event.target.closest('.readmoreinfo')) { return; }
                var sectionShow = document.querySelector('.' + element.getAttribute('rel'));
                window.location.href = "#open-sub-card";

                sectionShow.parentNode.children.classList.remove('current');

                if (!element.classList.contains('selected')) {
                    [...element.parentNode.children].forEach(function(sibling) {
                        if (sibling !== element && sibling.classList.contains('btn-bb-type')) {
                            sibling.classList.remove('selected');
                        }
                    });
                    element.classList.add('selected');
                    // azzero le selezioni (sia visual che dati);
                    sectionProductSelectors.forEach(function(selector) {
                        selector.querySelectorAll('.product-card-list').forEach(function(cardList) {
                            // console.log("selector parent", sectionProductSelectors[0].parentNode);
                            //console.log("selector", selector.querySelectorAll('.product-card-list').length);
                            if(selector.querySelectorAll('.product-card-list').length === 1){
                                //console.log(cardList);
                                cardList.classList.add('selected');
                                selector.classList.add('validated');
                                const dinNumber = selector.querySelector('.counter din');
                                dinNumber.textContent = 1;
                            } else {
                                cardList.classList.remove('disable', 'selected');
                                cardList.querySelectorAll('.product-card .overlay-info').forEach(function(overlay) {
                                    overlay.remove();
                                });
                            }
                        });
                    });
                    resetValidationAndData();
                }
                [...sectionShow.parentNode.children].forEach(function(sibling) {
                    sibling.style.display = 'none';
                    sectionShow.classList.remove('current');
                });
                sectionShow.style.display = 'flex';
                sectionShow.classList.add('current');
                if (element.classList.contains('selected')) {
                    sectionProductSelectors.forEach(function(selector) {
                        selector.querySelectorAll('.product-card-list').forEach(function(cardList) {
                            if(selector.querySelectorAll('.product-card-list').length === 1){
                                getProductSelect();
                                checkValidation();
                            }
                        });
                    });
                }

                MYBOXPAGE.gotoStep(2, false);
                if (!element.classList.contains('selected')) {
                    getProductSelect();
                }
            });

            if(!!stepperCont){
                stepperCont.addEventListener('click', function(event) {
                    if (e.currentTarget.matches('circle.past')) {
                        var stepNum = event.currentTarget.getAttribute('rel');
                        MYBOXPAGE.gotoStep(parseInt(stepNum), false);
                    }
                });
            }

            sectionProductSelectors.forEach(function(thisSel) {
                const maxProd = thisSel.getAttribute('maxprod');
                const dinNumber = thisSel.querySelector('.counter din');
                const productsCardListEnable = thisSel.querySelectorAll('.product-card-list');

                productsCardListEnable.forEach(function(element) {
                    if(productsCardListEnable.length === 1){
                        return;
                    }
                    element.addEventListener('click', function(event) {
                        const target = event.currentTarget;
                        if (target.classList.contains('disable')) { return; }
                        if (event.target.classList.contains('wishlist-btn')) { return; }
                        if (event.target.closest('.wishlist-btn')) { return; }

                        if (event.target.classList.contains('show-more-info-popup')) { return; }
                        if (event.target.closest('.show-more-info-popup')) { return; }

                        target.classList.toggle('selected');
                        const selNumber = target.parentElement.querySelectorAll('.product-card-list.selected').length;
                        //console.log("selNumber", selNumber);

                        if (selNumber >= maxProd) {
                            thisSel.classList.add('validated');
                            [...target.parentNode?.children].forEach(function(sibling) {
                                if (!sibling.classList.contains('selected')) {
                                    sibling.classList.add('disable');
                                    sibling.querySelector('.product-card').insertAdjacentHTML('beforeend', '<div style="display: none" class="overlay-info" tabindex="-1" tippy-default data-tippy-content="' + l10n.myBox.selectionComplete + '"></div>');
                                    sibling.querySelector('.overlay-info').style.display = 'block';
                                }
                            });
                            MAIN.initTooltip();
                        } else {
                            thisSel.classList.remove('validated');
                            [...target.parentNode?.children].forEach(function(sibling) {
                                sibling.classList.remove('disable');
                                sibling.querySelectorAll('.product-card .overlay-info').forEach(function(overlay) {
                                    overlay.remove();
                                });
                            });
                        }
                        dinNumber.textContent = selNumber;
                        getProductSelect();
                        checkValidation();
                    })
                });
            });

            document.querySelectorAll('.goto-form-btn').forEach(function(element) {
                element.addEventListener('click', function() {
                    if (!element.classList.contains('disable')) {
                        console.log(euroIt.format(boxValue).replace(/ /g, ''));
                        document.getElementById('box-value').textContent = euroIt.format(boxValue).replace(/\xa0/g, '');
                        MYBOXPAGE.gotoStep(3, false);
                    }
                });
            });

            let euroIt = new Intl.NumberFormat("it-IT", {
                style: "currency",
                currency: "EUR",
                currencySign: "accounting",
            });

            document.getElementById('third-party-form-submit')?.addEventListener('click', function(e) {
                e.preventDefault();
                if (!e.currentTarget.classList.contains('disable')) {
                    sendDataThirdParty();
                }
            });

            document.body.addEventListener('click', function(e) {
                if (e.currentTarget.matches('#all-checkbox')) {
                    var allCheck = true;
                    e.currentTarget.closest('.form-row').nextElementSibling.querySelectorAll('input[type=checkbox]').forEach(function(checkbox) {
                        if (!checkbox.checked) {
                            allCheck = false;
                            return;
                        }
                    });
                    if (!allCheck) {
                        e.currentTarget.closest('.form-row').nextElementSibling.querySelectorAll('input[type=checkbox]').forEach(function(checkbox) {
                            checkbox.checked = true;
                            checkbox.dispatchEvent(new Event('change'));
                        });
                        document.querySelectorAll('.checkbox-collapsed-container').forEach(function(container) {
                            container.style.height = '0px';
                        });
                    } else {
                        e.currentTarget.closest('.form-row').nextElementSibling.querySelectorAll('input[type=checkbox]').forEach(function(checkbox) {
                            checkbox.checked = false;
                            checkbox.dispatchEvent(new Event('change'));
                        });
                    }
                }
            });

            /* checkbox collassate */
            var cbCollWrap = document.querySelector('.all-checkbox-collapsed-wrap');
            var cbCollCont = document.querySelector('.checkbox-collapsed-container');
            if (cbCollWrap && cbCollCont) {

                document.body.addEventListener('click', function(e) {
                    if (e.currentTarget.matches('#all-checkbox')) {
                        var value = e.currentTarget.checked || false;
                        if (value) {
                            e.currentTarget.closest('.form-row').nextElementSibling.querySelectorAll('input[type=checkbox]').forEach(function(checkbox) {
                                checkbox.checked = true;
                                checkbox.dispatchEvent(new Event('change'));
                            });
                            document.querySelectorAll('.checkbox-collapsed-container').forEach(function(container) {
                                container.style.height = '0px';
                            });
                        } else {
                            e.currentTarget.closest('.form-row').nextElementSibling.querySelectorAll('input[type=checkbox]').forEach(function(checkbox) {
                                checkbox.checked = false;
                                checkbox.dispatchEvent(new Event('change'));
                            });
                        }
                    }
                });

                document.body.addEventListener('click', function(e) {
                    if (e.currentTarget.matches('label[for=all-checkbox] btn')) {
                        e.preventDefault();
                        var container = e.currentTarget.closest('.form-row').nextElementSibling;
                        if (container.style.height !== '0px') {
                            container.style.height = '0px';
                        } else {
                            container.style.height = 'auto';
                        }
                    }
                });

                document.getElementById('checkbox-collapsed-container')?.addEventListener('change', function(e) {
                    if (e.currentTarget.matches('input[type=checkbox]')) {
                        areAllCheckboxChecked();
                    }
                });

                function areAllCheckboxChecked() {
                    const originalContainer = document.getElementById('third-party-form');
                    var allCheck = true;
                    originalContainer.querySelectorAll('.checkbox-collapsed-container input[type=checkbox]').forEach(function(checkbox) {
                        if (!checkbox.checked) {
                            allCheck = false;
                            return;
                        }
                    });
                    if (allCheck) {
                        originalContainer.querySelector('input#all-checkbox').checked = true;
                        document.querySelectorAll('.checkbox-collapsed-container').forEach(function(container) {
                            container.style.height = '0px';
                        });
                    } else {
                        originalContainer.querySelector('input#all-checkbox').checked = false;
                    }
                }

            }
            /* FINE checkbox collassate */

            const submitBtn = document.getElementById('third-party-form-submit');
            const regEmail = document.getElementById('reg_email');
            const mandatory = document.getElementById('mandatory');

            var emailFromUrl = MAIN.getUrlParameter('email');
            if (emailFromUrl) {
                regEmail.value = emailFromUrl;
                checkValidationThirdParty();
            }

            mandatory?.addEventListener('click', function() {
                checkValidationThirdParty();
            });

            regEmail?.addEventListener('keyup', function() {
                checkValidationThirdParty();
            });

            function checkValidationThirdParty() {
                var valid = true;
                var mandatoryCheck = document.getElementById('mandatory');
                if (!validateEmail(regEmail.value)) {
                    console.log("EMAIL INVALIDA");
                    valid = false;
                    regEmail.closest('.validate-required').classList.add('validation-error');
                    regEmail.closest('.validate-required').classList.remove('validated');
                } else {
                    regEmail.closest('.validate-required').classList.remove('validation-error');
                    regEmail.closest('.validate-required').classList.add('validated');
                }
                if (mandatoryCheck) {
                    if (!mandatoryCheck.checked) {
                        console.log("CKKK INVALIDA");
                        valid = false;
                    }
                }
                if (valid) {
                    submitBtn.classList.remove('disable');
                } else {
                    submitBtn.classList.add('disable');
                }
            }

            function validateEmail(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            }

            function sendDataThirdParty() {

                var ajaxUrl = '/lead/save';

                var productData = [];
                for (var i in MYBOXPAGE.vars.productSelectSkuArray) {
                    productData.push({
                        sku: MYBOXPAGE.vars.productSelectSkuArray[i],
                        quantity: 1,
                    });
                }

                var param = {
                    'email': document.getElementById('reg_email')?.value,
                    'campaign': document.getElementById('third-party-form')?.getAttribute('campaign_name'),
                    '_wpnonce': document.getElementById('_wpnonce')?.value,
                    'privacy': document.getElementById('mandatory')?.checked,
                    'marketing': document.getElementById('marketing')?.checked,
                    'profiling': document.getElementById('profiling')?.checked,
                    'marketing3rd': document.getElementById('marketing-3rd')?.checked,
                    'products': productData
                }
                param = JSON.stringify(param);

                MAIN.openVeil();

                fetch(ajaxUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json; charset=utf-8"
                    },
                    body: param
                })
                    .then(response => response.json())
                    .then(data => {
                        console.log(data);
                        MAIN.closeVeil();
                        document.querySelector('#third-party-form').classList.add('hide');
                        document.querySelector('#success-message').classList.remove('hide');
                    })
                    .catch(error => {
                        MAIN.closeVeil();
                        console.log(error);
                        const errorMessage = document.querySelector('#success-message').getAttribute('error');
                        eventBus.$emit('addNoticeMessage', {type : 'error', title : '', message : [ errorMessage ], time : 0});
                    });
            }

            document.querySelectorAll('.goto-summary-btn').addEventListener('click', function() {
                if (!this.classList.contains('disable')) {
                    var productData = [];
                    for (var i in MYBOXPAGE.vars.productSelectArray) {
                        productData.push({
                            id: MYBOXPAGE.vars.productSelectArray[i],
                            quantity: 1,
                        });
                    }

                    for (i in globalProductsToAdd) {
                        productData.push({
                            id: globalProductsToAdd[i],
                            quantity: 1,
                        });
                    }

                    var data = {
                        products: productData,
                    };
                    if (couponSelected !== undefined)
                        data.coupon = couponSelected;

                    console.log("productData", data);
                    MAIN.openVeil();

                    var myBoxPageInterval = setInterval(function() {
                        var abandonedMyBoxPage = MAIN.getCookie('abandonedMyBoxPage');
                        var timePassed = Math.round(new Date().getTime() / 1000) - abandonedMyBoxPage;
                        if (timePassed > 15) {
                            MAIN.closeVeil();
                            MAIN.setCookie('abandonedMyBoxPage', 'false', -1);
                            clearInterval(myBoxPageInterval);
                        }
                    }, 250);

                    var base64String = btoa(JSON.stringify(data));
                    var checkoutUrl = '/checkout/?no-notice&recover-cart=' + base64String;
                    // console.log(checkoutUrl);
                    window.location.href = checkoutUrl;
                }
            });

            function productSummaryEventComplete() {
                MAIN.closeVeil();
                MAIN.scrollToElement(document.getElementById('formMyBox'));
                MYBOXPAGE.gotoStep(3, false);
            }

            function getProductSelect() {
                var sectionProductSelectorsCurrent = document.querySelectorAll('.step2-section.current .section-product-selector');

                console.log("sectionProductSelectorsCurrent", sectionProductSelectorsCurrent);

                var parentSection = sectionProductSelectorsCurrent[0].parentElement;
                couponSelected = parentSection.dataset.coupon;

                MYBOXPAGE.vars.productSelectArray = [];
                MYBOXPAGE.vars.productSelectSkuArray = [];
                boxValue = 0;

                sectionProductSelectorsCurrent.forEach(function(selector, index) {
                    selector.querySelectorAll('.product-card-list.selected .product-card').forEach(function(card) {
                        MYBOXPAGE.vars.productSelectArray.push(card.getAttribute('data-product'));
                        MYBOXPAGE.vars.productSelectSkuArray.push(card.getAttribute('data-sku'));
                        boxValue += parseFloat(card.getAttribute('data-full-price'));
                    });
                    var sectionObj = {};
                    sectionObj.pos = index;
                    sectionObj.title = selector.querySelector('.title-js').textContent;
                    sectionObj.products = [];
                    selector.querySelectorAll('.product-card-list.selected .product-card').forEach(function(card) {
                        sectionObj.products.push(card.getAttribute('data-sku'));
                    });
                });
                boxValue += 30.70; // valore arbitrario aggiunto su richiesta di Enrico
                //console.log('boxValue: ' + boxValue);
            }

            function checkValidation() {
                var sectionProductSelectorsCurrent = document.querySelector('.step2-section.current');
                var valid = true;
                sectionProductSelectorsCurrent.querySelectorAll('.section-product-selector').forEach(function(selector) {
                    if (!selector.classList.contains('validated')) {
                        valid = false;
                    }
                });
                if (valid) {
                    sectionProductSelectorsCurrent.querySelector('.goto-summary-btn')?.classList.remove('hide');
                    sectionProductSelectorsCurrent.querySelector('.goto-summary-btn-disable')?.classList.add('hide');
                    sectionProductSelectorsCurrent.querySelector('.goto-form-btn')?.classList.remove('disable');
                } else {
                    sectionProductSelectorsCurrent.querySelector('.goto-summary-btn-disable')?.classList.remove('hide');
                    sectionProductSelectorsCurrent.querySelector('.goto-summary-btn')?.classList.add('hide');
                    sectionProductSelectorsCurrent.querySelector('.goto-form-btn')?.classList.add('disable');
                }
            }

            function resetValidationAndData() {
                MYBOXPAGE.vars.productSelectArray = [];

                var step2Section = document.querySelector('.step2-section');
                step2Section.querySelector('.goto-summary-btn-disable').classList.remove('hide');
                step2Section.querySelector('.goto-summary-btn').classList.add('hide');
            }

        }

    },

    gotoStep: function(_step, _onload){
        if(!_onload){
            MYBOXPAGE.collapseExpandPreSiblings(_step);
        }
        MYBOXPAGE.openSection(_step);
    },

    collapseExpandPreSiblings: function(_step){
        const formMyBox = document.getElementById('form-my-box');
        var siblings = formMyBox.parentNode.children;
        if (_step === 1) {
            [...siblings].forEach(function (sibling){
                if(sibling !== formMyBox && sibling.nodeName.toLowerCase() !== 'script'){
                    sibling.style.display = 'block';
                }
            })
            setTimeout(function(){
                formMyBox.scrollIntoView({
                    block: 'start',
                    behavior: 'smooth'
                });
            }, 600);
        } else {
            [...siblings].forEach(function (sibling){
                if(sibling !== formMyBox){
                    sibling.style.display = 'none';
                }
            })
            window.scrollTo(0,0);
        }
    },

    openSection: function(_n){
        //console.log("STEP", _n);
        const sectionStepItems = document.querySelectorAll('.step-slider .step-item');
        const sectionStepCont = document.querySelector('.step-slider');
        sectionStepItems.forEach(item => item.classList.remove('current'));
        sectionStepItems[_n - 1].classList.add('current');
        sectionStepCont.querySelectorAll('.step-item:not(.current)').forEach(item => item.style.height = '0px');
        sectionStepItems[_n - 1].style.height = 'auto';
    }

}

document.addEventListener('DOMContentLoaded', function () {
    MYBOXPAGE.init();
});